import { useUiFramework } from '../../providers/UiFrameworkProvider'

import { RecurrenceWhenDropdown as LegacyRecurrenceWhenDropdown } from './legacy/RecurrenceWhenDropdown'
import { RecurrenceWhenDropdown as TidalRecurrenceWhenDropdown } from './tidal/RecurrenceWhenDropdown'

export function RecurrenceWhenDropdown() {
  const uiFramework = useUiFramework()

  switch (uiFramework) {
    case 'legacy':
      return <LegacyRecurrenceWhenDropdown />

    case 'tidal':
      return <TidalRecurrenceWhenDropdown />
  }
}
